import api from "./api/api";

export interface CopilotoMessage {
  role: "user" | "assistant";
  content: string;
}

export interface CopilotoResponse {
  success: boolean;
  reply: string;
  toolsUsed?: string[];
  message?: string;
}

export const CopilotoService = {
  /**
   * Envia a mensagem atual + histórico recente para o Copiloto Ad Desk.
   * O backend consulta os dados da empresa via tool-calling e retorna a resposta.
   */
  sendMessage: async (
    message: string,
    history: CopilotoMessage[],
  ): Promise<CopilotoResponse> => {
    try {
      const res = await api.post("/ia/copiloto", {
        message,
        messages: history,
      });
      return res.data as CopilotoResponse;
    } catch (error: any) {
      const status = error?.response?.status;
      const backendMsg = error?.response?.data?.message;
      return {
        success: false,
        reply: "",
        message:
          backendMsg ||
          (status === 503
            ? "O Copiloto Ad Desk ainda não está configurado."
            : "Não consegui responder agora. Tente novamente em instantes."),
      };
    }
  },
};
